import { getAbTestEligibility } from 'dibs-cookie-jar/exports/abTestHelpers';

type FeatureRampingAllocation = { MIN: number; MAX: number };

export const isFeatureRampingVariant = ({ MIN, MAX }: FeatureRampingAllocation): boolean => {
    const { eligibility } = getAbTestEligibility(document.cookie);
    const allocation = parseInt(eligibility, 10);

    return allocation >= MIN && allocation <= MAX;
};
